// extracted by mini-css-extract-plugin
export default {"navbarHeight":"60px","result":"styles_result__4KGja","description":"styles_description__Q0D3w","icon":"styles_icon__aUMLi"};